import React, { useState, useEffect } from 'react';

const OrderSheet = ({ 
  orderData, 
  onClose,
  onPrint 
}) => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 50);
    return () => clearTimeout(timer);
  }, []);

  // 格式化日期时间
  const formatDateTime = (date) => {
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };
    return new Date(date).toLocaleString('zh-CN', options);
  };

  // 按分类组织菜品
  const groupedItems = orderData.items.reduce((acc, item) => {
    const categoryName = item.categoryName || '未分类';
    if (!acc[categoryName]) {
      acc[categoryName] = [];
    }
    acc[categoryName].push(item);
    return acc;
  }, {});

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className={`bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 overflow-hidden transition-all duration-300 transform ${
        showContent ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      }`}>
        {/* 标题栏 */}
        <div className="px-6 py-2 bg-gradient-to-r from-indigo-50 to-white border-b flex justify-between items-center">
          <div>
            <h2 className="text-md font-semibold text-gray-800">点菜单</h2>
            <p className="text-sm text-gray-500">My Orders</p>
          </div>
          <div className="flex space-x-2">

            <button
              onClick={onClose}
              className="p-2 text-gray-500 hover:text-gray-700 rounded-lg hover:bg-gray-100"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* 点菜单内容 */}
        <div className="px-6 py-2 max-h-[70vh] overflow-y-auto">
          {/* 分类菜品列表 */}
          {Object.entries(groupedItems).map(([category, items], categoryIndex) => (
            <div key={categoryIndex} className="mb-2 last:mb-0">
              <h3 className="text-lg font-medium text-gray-700 mb-1 pb-2 border-b">
                {category}
              </h3>
              <div className="">
                {items.map((item, index) => (
                  <div 
                    key={index}
                    className="flex items-start justify-between py-1"
                  >
                    <div className="flex-1">
                      <p className="text-base font-medium">{item.rawName}</p>
                      {(item.selectedOption || item.selectedAddon) && (
                        <div className="mt-1 space-x-2 text-sm text-gray-600">
                          {item.selectedOption && (
                            <span className="bg-gray-50 px-2 py-0.5 rounded">
                              {item.selectedOption.raw_title}
                            </span>
                          )}
                          {item.selectedAddon && (
                            <span className="bg-gray-50 px-2 py-0.5 rounded">
                              + {item.selectedAddon.raw_title}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="text-right ml-4">
                      <span className="text-base font-medium">×{item.quantity}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}


          {/* 备注区域 */}
          {/* <div className="mt-6 pt-4 border-t">
            <div className="border border-dashed rounded p-3 min-h-[60px] bg-gray-50"></div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default OrderSheet; 